// React imports
import { useContext } from "react";

// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

export const StepChanger = ({
  steps,
  activeStep,
  setActiveStep,
  order,
  shipmentOne,
  shipmentTwo,
  addressConfirmed, // new prop
}) => {
  const { setAlertNotification } = useContext(AlertNotificationContext);

  const handleNext = () => {
    if (activeStep === 0) {
      // Check if we can proceed to Delivery
      if (staffCheck()) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    } else if (activeStep === 1) {
      // Check if we can proceed to Shipment Options
      if (postCodeCheck()) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    } else if (activeStep === 2) {
      // Check if we can proceed to Submit
      if (shippingServiceCheck()) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  // Check if Shipping services have been seleced
  const shippingServiceCheck = () => {
    // Check ShipmentOne
    if (shipmentOne.shipping.index === "") {
      setAlertNotification({
        message: `Please select a shipping service`,
        severity: "warning",
      });
      return false;
    }
    // Check Shipment Two only if it has lines
    if (shipmentTwo.lines.length > 0 && shipmentTwo.shipping.index === "") {
      setAlertNotification({
        message: `Please select a shipping service`,
        severity: "warning",
      });
      return false;
    }
    return true;
  };

  // Check if postcode is in the banned postcode list
  const bannedPostcodes = ["B504HF", "N227DE"];
  const postCodeCheck = () => {
    const postcode = order.data.order.postCode.replace(/\s/g, "");
    if (bannedPostcodes.includes(postcode)) {
      setAlertNotification({
        message: `We cannot deliver to this postcode`,
        severity: "warning",
      });
      return false;
    } else {
      return true;
    }
  };

  // Check if order has staff when moving from Step0 to Step1
  const staffCheck = () => {
    if (!order.data.staff) {
      setAlertNotification({
        message: `Please add some staff to the order`,
        severity: "warning",
      });
      return false;
    } else {
      if (!staffItemsCheck(order.data.staff)) {
        setAlertNotification({
          message: `A staff member has no items`,
          severity: "warning",
        });
        return false;
      }
      if (!staffReasonCheck(order.data.staff)) {
        setAlertNotification({
          message: `Please set order reason`,
          severity: "warning",
        });
        return false;
      }
      if (!staffBlockedCheck(order.data.staff)) {
        setAlertNotification({
          message: `A staff member is blocked`,
          severity: "warning",
        });
        return false;
      }
      if (!staffContractBlockedCheck(order.data.staff)) {
        setAlertNotification({
          message: `A staff member has a blocked contract`,
          severity: "warning",
        });
        return false;
      }
    }
    return true;
  };

  // Check if any staff have no items
  const staffItemsCheck = (staff) => {
    let pass = true;
    staff.map((person) => {
      if (person.numberOfLines < 1) pass = false;
    });
    return pass;
  };

  // Check if any staff don't have an order reason
  const staffReasonCheck = (staff) => {
    let pass = true;
    staff.map((person) => {
      if (!person.reasonCode) pass = false;
    });
    return pass;
  };

  // Check if any staff are blocked
  const staffBlockedCheck = (staff) => {
    let pass = true;
    staff.map((person) => {
      if (person.blocked === "Yes") pass = false;
    });
    return pass;
  };

  // Check if any staff are have a blocked contract
  const staffContractBlockedCheck = (staff) => {
    let pass = true;
    staff.map((person) => {
      if (person.contractBlocked === "Yes") pass = false;
    });
    return pass;
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "row", pt: 2, pb: 1 }}>
      {/* {activeStep <= 2 && ( */}
      {activeStep <= 3 && (
        <Button
          color="inherit"
          disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ mr: 1 }}
        >
          Back
        </Button>
      )}
      <Box sx={{ flex: "1 1 auto" }} />
      {activeStep <= 2 && (
        <Button
          onClick={handleNext}
          disabled={
            !order.data.order.no ||
            (activeStep === 1 && addressConfirmed === false)
          }
        >
          {activeStep === steps.length - 1 ? "Submit Order" : "Next"}
        </Button>
      )}
    </Box>
  );
};
